/* eslint-disable max-len */
import { CloseIcon, DownloadTaskIcon } from "../../../../../../../v1/components/atoms/Icons";
import { Spinner } from "../../../../../../../v1/components/atoms/Spinner/Spinner";
import Tooltip from "../../../../../../../v1/components/atoms/Tooltip";
import { AssetStatus } from "../../../../../../../v1/components/pages/GameDetail/components/AssetsTab/utils/constants";
import { useTranslation } from "../../../../../../hooks/useTranslation";
import { cancelTask } from "../../../../../../service/tasksService";
import { useRequestsStore } from "../../../../../../store/useRequestsStore/useRequestsStore";
import { ITask } from "../../../../../../types/Task/Task.interface";
import { capitalize } from "../../../../../../utils/capitalize";
import { isEmpty } from "../../../../../../utils/isEmpty";
import {
  TaskStatus,
  TaskStatusProductLabel,
} from "../../../../../pages/Tasks/MyTasks/utils/constants";
import { LoadingTasks } from "../../atoms/LoadingTasks";
import { TaskStatusIcon } from "../../atoms/TaskStatus";

interface ITaskList {
  tasks: ITask[];
}

export const TaskList: React.FC<ITaskList> = ({ tasks }) => {
  const { downloadAsset, queue } = useRequestsStore();
  const { t } = useTranslation();

  const quantityString = (quantity: number): string => {
    if (isEmpty(quantity)) return "";
    if (quantity === 0) return t("label.all-games");
    return `${quantity} ${quantity > 1 ? t("label.games") : t("label.game")}`;
  };

  const isDownloading = (task: ITask) =>
    queue.some(
      (item) =>
        item.path?.includes(task.result?.data?.file?.assetKey as string) &&
        item.status !== AssetStatus.SUCCESS,
    );

  const isCancelable = (task: ITask) =>
    [TaskStatus.PENDING, TaskStatus.SCHEDULED].includes(task.status);

  const isCompleted = (task: ITask) => task.status === TaskStatus.COMPLETED;
  const hasWarning = (task: ITask) => task.status === TaskStatus.WARNING;
  const getDownloadKey = (task: ITask) => task.result?.data?.file?.assetKey;
  const getAssetType = (task: ITask) => task.result?.data?.file?.assetType;

  return (
    <>
      {isEmpty(tasks) ? (
        <LoadingTasks />
      ) : (
        <ul className="tasks-list">
          {tasks.map((task: ITask) => {
            return (
              <li key={task.id} className={`task ${task.status}`}>
                <Tooltip message={capitalize(TaskStatusProductLabel[task.status])}>
                  <TaskStatusIcon status={task.status} />
                </Tooltip>
                <p className="description">
                  <strong>{capitalize(task.type.replace(/_/g, " "))} </strong>
                  {quantityString(task.payload.id?.length)}
                </p>
                {(isCompleted(task) || hasWarning(task)) && getDownloadKey(task) && (
                  <button
                    disabled={isDownloading(task)}
                    className="download"
                    onClick={() => {
                      downloadAsset(
                        task.type,
                        // eslint-disable-next-line max-len
                        `/assets/download-file?key=${getDownloadKey(task)}&type=${getAssetType(
                          task,
                        )}`,
                        undefined,
                        false,
                      );
                    }}
                  >
                    {isDownloading(task) && <Spinner />}
                    <DownloadTaskIcon />
                  </button>
                )}
                {isCancelable(task) && (
                  <button
                    className="cancel"
                    onClick={() => {
                      cancelTask(task.id);
                    }}
                  >
                    <CloseIcon />
                  </button>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </>
  );
};
